export default __webpack_public_path__ + "static/media/03.2.5216def5.jpg";